function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSerbia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: 30,
    height: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M0 22.581c0 1.24 1.007 2.247 2.247 2.247h25.506c1.24 0 2.247 -1.007 2.247 -2.247v-4.305H0V22.581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M27.753 5.172H2.247C1.007 5.172 0 6.178 0 7.419v4.305h30v-4.305C30 6.178 28.994 5.172 27.753 5.172z"
  }), /*#__PURE__*/React.createElement("path", {
    y: 200.09,
    style: {
      fill: "#41479B"
    },
    width: 512,
    height: 111.81,
    d: "M0 11.724H30V18.276H0V11.724z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    points: "173.021,200.07 109.462,200.07 106.814,184.18 175.669,184.18 ",
    d: "M10.139 11.723L6.414 11.723L6.258 10.793L10.293 10.793Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD350"
    },
    points: "108.8,196.097 109.462,200.07 173.021,200.07 173.683,196.097 ",
    d: "M6.375 11.49L6.414 11.723L10.139 11.723L10.176 11.49Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    x: 139.92,
    y: 147.1,
    style: {
      fill: "#FFE15A"
    },
    width: 2.648,
    height: 10.593,
    d: "M8.199 8.619H8.353V9.24H8.199V8.619z"
  }), /*#__PURE__*/React.createElement("path", {
    x: 137.27,
    y: 149.75,
    style: {
      fill: "#FFE15A"
    },
    width: 7.945,
    height: 2.648,
    d: "M8.043 8.775H8.508V8.93H8.043V8.775z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M10.151 11.101c-0.018 0 -0.036 -0.003 -0.053 -0.009c-0.081 -0.029 -0.122 -0.119 -0.093 -0.2l0.328 -0.907c0.016 -0.045 0.012 -0.095 -0.011 -0.136c-0.012 -0.022 -0.041 -0.06 -0.095 -0.072c-0.4 -0.086 -1.178 -0.228 -1.876 -0.228h-0.15c-0.699 0 -1.476 0.142 -1.876 0.228c-0.054 0.012 -0.083 0.05 -0.095 0.072c-0.022 0.042 -0.027 0.091 -0.011 0.136l0.328 0.907c0.029 0.081 -0.012 0.17 -0.093 0.2c-0.081 0.029 -0.17 -0.012 -0.2 -0.093l-0.328 -0.907c-0.046 -0.129 -0.036 -0.273 0.032 -0.392c0.064 -0.116 0.174 -0.198 0.302 -0.225c0.413 -0.088 1.213 -0.236 1.941 -0.236h0.15c0.727 0 1.528 0.147 1.941 0.236c0.128 0.027 0.237 0.109 0.302 0.225c0.066 0.12 0.078 0.263 0.032 0.392l-0.328 0.907C10.274 11.063 10.214 11.101 10.151 11.101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M8.277 10.966c-0.086 0 -0.155 -0.069 -0.155 -0.155v-1.262c0 -0.086 0.069 -0.155 0.155 -0.155s0.155 0.069 0.155 0.155v1.262C8.432 10.897 8.363 10.966 8.277 10.966z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M9.349 11.101c-0.011 0 -0.021 -0.002 -0.032 -0.003c-0.084 -0.018 -0.138 -0.099 -0.12 -0.183l0.188 -0.907c0.024 -0.119 -0.013 -0.222 -0.036 -0.24c-0.214 -0.08 -0.646 -0.217 -1.031 -0.217h-0.086c-0.384 0 -0.816 0.139 -1.039 0.222c-0.013 0.013 -0.053 0.117 -0.027 0.236l0.188 0.907c0.018 0.084 -0.036 0.167 -0.12 0.183c-0.084 0.016 -0.167 -0.036 -0.183 -0.12l-0.188 -0.907c-0.046 -0.227 0.026 -0.516 0.223 -0.59c0.297 -0.111 0.737 -0.242 1.148 -0.242h0.086c0.411 0 0.85 0.132 1.148 0.242c0.198 0.073 0.27 0.363 0.223 0.59l-0.188 0.907C9.486 11.052 9.421 11.101 9.349 11.101z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD350"
    },
    points: "107.476,188.152 175.007,188.152 175.669,184.18 106.814,184.18 ",
    d: "M6.297 11.025L10.254 11.025L10.293 10.793L6.258 10.793Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M5.328 11.723c-0.086 0 -0.155 0.069 -0.155 0.155v5.42c0 1.721 1.389 3.115 3.103 3.115s3.103 -1.395 3.103 -3.115v-5.42c0 -0.086 -0.069 -0.155 -0.155 -0.155L5.328 11.723L5.328 11.723z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M8.586 16.843l0.31 -0.775l-0.621 0.155l-0.621 -0.155l0.31 0.775l-0.775 2.638c0 0 0.465 0.31 1.086 0.31s1.086 -0.31 1.086 -0.31L8.586 16.843z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    points: "122.061,298.135 117.388,299.304 127.667,280.802 123.037,278.232 110.552,300.704  98.869,300.704 98.869,306.001 104.559,306.001 97.215,311.876 100.523,316.014 106.762,311.022 104.301,318.403 109.326,320.079  114.163,305.568 123.346,303.272 ",
    d: "M7.152 17.469L6.878 17.538L7.481 16.453L7.209 16.302L6.477 17.619L5.793 17.619L5.793 17.93L6.126 17.93L5.695 18.274L5.891 18.516L6.255 18.223L6.111 18.657L6.407 18.755L6.688 17.904L7.227 17.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M7.189 13.275l-0.708 -0.354c-0.13 -0.064 -0.198 -0.211 -0.162 -0.352l0.041 -0.161c0.029 -0.111 -0.057 -0.219 -0.171 -0.219c-0.054 0 -0.104 0.024 -0.138 0.066c-0.368 0.459 -0.569 1.031 -0.569 1.618v3.28c0 0 0.648 -0.129 1.233 -0.981c0.108 -0.156 0.285 -0.249 0.472 -0.258l-0.309 0.928L7.5 16.998l0.543 -0.646L7.189 13.275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    points: "160.422,298.135 165.095,299.304 154.816,280.802 159.446,278.232 171.929,300.704  183.614,300.704 183.614,306.001 177.923,306.001 185.268,311.876 181.96,316.014 175.721,311.022 178.182,318.403 173.156,320.079  168.32,305.568 159.137,303.272 ",
    d: "M9.399 17.469L9.673 17.538L9.072 16.453L9.342 16.302L10.074 17.619L10.758 17.619L10.758 17.93L10.425 17.93L10.856 18.274L10.662 18.516L10.296 18.223L10.44 18.657L10.146 18.755L9.863 17.904L9.324 17.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M9.361 13.275l0.708 -0.354c0.13 -0.064 0.198 -0.211 0.162 -0.352l-0.041 -0.161c-0.029 -0.111 0.057 -0.219 0.171 -0.219c0.054 0 0.104 0.024 0.138 0.066c0.368 0.459 0.569 1.031 0.569 1.618v3.28c0 0 -0.648 -0.129 -1.233 -0.981c-0.108 -0.156 -0.285 -0.249 -0.472 -0.258l0.309 0.928l-0.621 0.155l-0.543 -0.646L9.361 13.275z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    points: "125.352,208.014 112.11,208.014 116.083,213.311 125.352,215.959 120.055,218.607  128,218.607  ",
    d: "M7.345 12.189L6.568 12.189L6.801 12.498L7.345 12.654L7.035 12.809L7.5 12.809Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    points: "157.131,208.014 170.372,208.014 166.4,213.311 157.131,215.959 162.428,218.607  154.483,218.607  ",
    d: "M9.207 12.189L9.982 12.189L9.75 12.498L9.207 12.654L9.517 12.809L9.051 12.809Z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M9.316 12.066l-0.731 0.122l-0.31 0.621l-0.31 -0.621l-0.731 -0.122c-0.084 -0.013 -0.148 0.073 -0.109 0.148l0.375 0.749l-0.31 0.31h1.086h1.086l-0.31 -0.31l0.375 -0.749C9.464 12.14 9.401 12.052 9.316 12.066z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBE50"
    },
    cx: 141.24,
    cy: 185.34,
    r: 3.972,
    d: "M8.508 10.86A0.233 0.233 0 0 1 8.276 11.092A0.233 0.233 0 0 1 8.043 10.86A0.233 0.233 0 0 1 8.508 10.86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    cx: 141.19,
    cy: 194.82,
    rx: 3.139,
    ry: 2.207,
    d: "M8.457 11.415A0.184 0.129 0 0 1 8.272 11.544A0.184 0.129 0 0 1 8.089 11.415A0.184 0.129 0 0 1 8.457 11.415z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    cx: 125.52,
    cy: 194.82,
    rx: 3.139,
    ry: 2.207,
    d: "M7.539 11.415A0.184 0.129 0 0 1 7.354 11.544A0.184 0.129 0 0 1 7.171 11.415A0.184 0.129 0 0 1 7.539 11.415z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    cx: 109.85,
    cy: 194.82,
    rx: 3.139,
    ry: 2.207,
    d: "M6.621 11.415A0.184 0.129 0 0 1 6.437 11.544A0.184 0.129 0 0 1 6.252 11.415A0.184 0.129 0 0 1 6.621 11.415z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    cx: 172.52,
    cy: 194.82,
    rx: 3.139,
    ry: 2.207,
    d: "M10.293 11.415A0.184 0.129 0 0 1 10.109 11.544A0.184 0.129 0 0 1 9.924 11.415A0.184 0.129 0 0 1 10.293 11.415z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    cx: 156.85,
    cy: 194.82,
    rx: 3.139,
    ry: 2.207,
    d: "M9.375 11.415A0.184 0.129 0 0 1 9.19 11.544A0.184 0.129 0 0 1 9.006 11.415A0.184 0.129 0 0 1 9.375 11.415z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBE50"
    },
    cx: 159.65,
    cy: 185.34,
    r: 3.972,
    d: "M9.586 10.86A0.233 0.233 0 0 1 9.354 11.092A0.233 0.233 0 0 1 9.122 10.86A0.233 0.233 0 0 1 9.586 10.86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBE50"
    },
    cx: 174.17,
    cy: 185.34,
    r: 3.972,
    d: "M10.439 10.86A0.233 0.233 0 0 1 10.206 11.092A0.233 0.233 0 0 1 9.972 10.86A0.233 0.233 0 0 1 10.439 10.86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBE50"
    },
    cx: 122.86,
    cy: 185.34,
    r: 3.972,
    d: "M7.431 10.86A0.233 0.233 0 0 1 7.199 11.092A0.233 0.233 0 0 1 6.966 10.86A0.233 0.233 0 0 1 7.431 10.86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBE50"
    },
    cx: 108.33,
    cy: 185.34,
    r: 3.972,
    d: "M6.58 10.86A0.233 0.233 0 0 1 6.348 11.092A0.233 0.233 0 0 1 6.114 10.86A0.233 0.233 0 0 1 6.58 10.86z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M8.543 9.551c0.027 -0.046 0.044 -0.099 0.044 -0.155c0 -0.171 -0.139 -0.31 -0.31 -0.31s-0.31 0.139 -0.31 0.31c0 0.057 0.016 0.109 0.044 0.155H8.543z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M8.276 16.455c-0.642 0 -1.164 -0.522 -1.164 -1.164v-2.096h2.328v2.096C9.439 15.933 8.918 16.455 8.276 16.455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A54B50"
    },
    d: "M9.361 13.275v2.017c0 0.6 -0.486 1.086 -1.086 1.086s-1.086 -0.486 -1.086 -1.086v-2.017H9.361M9.517 13.119h-0.155h-2.172h-0.155v0.155v2.017c0 0.684 0.556 1.242 1.242 1.242c0.684 0 1.242 -0.556 1.242 -1.242v-2.017V13.119L9.517 13.119z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M8.043 16.353c0.075 0.016 0.153 0.026 0.233 0.026s0.158 -0.009 0.233 -0.026v-3.078h-0.465C8.043 13.275 8.043 16.353 8.043 16.353z"
  }), /*#__PURE__*/React.createElement("path", {
    x: 122.7,
    y: 248.4,
    style: {
      fill: "#F5F5F5"
    },
    width: 37.08,
    height: 7.945,
    d: "M7.189 14.555H9.361V15.019H7.189V14.555z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSerbia);
export default __webpack_public_path__ + "static/media/Serbia.aa4330fdb4ba6aa6f309222352ab7a81.svg";
export { ForwardRef as ReactComponent };